export enum OrderChannel {
  CREATE = 'order::create',
  EDIT = 'order::patch',
  DELETE = 'order::delete',
}
